import { Navigate, useRoutes } from 'react-router-dom';
// import MainLayout from '../shared/layouts/mainLayout';
import {
	AbsherVerificationGuard,
	AlreadyLogin,
	BorrowerRole,
	CheckLogin,
	InvestorRole,
	InvestorTransferGuard,
	KSATransferGuard,
	NafathVerificationGuard,
	RegistrationLoginCheck,
	ThankYouPageGuard,
	UserNafathGuard,
} from '../auth/authContext';
import { IS_SA } from '../config/appConfig';
import { ForgotPassword } from '../auth/views/forgotPassword';
import Login from '../auth/views/login';
import { ResetPassword } from '../auth/views/resetPassword';
import { AppRoutes } from '../constants/appRoutes';
import { Borrower } from '../pages/borrower';
import BankTransfer from '../pages/borrower/view/bankTransfer';
import { BorrowerChangePassword } from '../pages/borrower/view/changePassword';
import { DepositHistory } from '../pages/borrower/view/depositHistory';
import { BorrowerPaymentSchedule } from '../pages/borrower/view/paymentSchedule';
import { BorrowerProfile } from '../pages/borrower/view/profile';
import { BorrowerDeactivateAccount } from '../pages/borrower/view/profile/deactivateAccount';
import { BorrowerProfileSections } from '../pages/borrower/view/profile/profileSections';
import { BorrowerUpdateDetails } from '../pages/borrower/view/profile/updateDetails';
import { BorrowerSummary } from '../pages/borrower/view/summary';
import { BorrowerTransfers } from '../pages/borrower/view/transfers';
import { Investor } from '../pages/investor';
import { AutoInvesting } from '../pages/investor/views/auto-investing';
import { BecomeProInvestor } from '../pages/investor/views/becomePro';
import { InvestorChangePassword } from '../pages/investor/views/changePassword';
import { Marketplace } from '../pages/investor/views/marketplace';
import { BusinessDetailsHistory } from '../pages/investor/views/marketplace/businesDetailHistory';
import { PaymentSchedule } from '../pages/investor/views/marketplace/businesDetailHistory/paymentSchedule';
import { MarketplaceDetails } from '../pages/investor/views/marketplace/businessDetails';
import { MarketplaceCollectionDetails } from '../pages/investor/views/marketplace/collectionDetails/index';
import { Portfolio } from '../pages/investor/views/portfolio';
import { InvestorProfile } from '../pages/investor/views/profile';
import { InvestorDeactivateAccount } from '../pages/investor/views/profile/deactivateAccount';
import { ProfileSections } from '../pages/investor/views/profile/profileSections';
import { InvestorUpdateDeatils } from '../pages/investor/views/profile/updateDeatils';
import { InvestorSummary } from '../pages/investor/views/summary';
import { TransactionStatements } from '../pages/investor/views/transactionStatements';
import { InvestorTransfer } from '../pages/investor/views/transfers';
import { InvestorDeposit } from '../pages/investor/views/transfers/deposit';
import { InvestorDepositHistory } from '../pages/investor/views/transfers/depositHistory';
import { InvestorTransferHistory } from '../pages/investor/views/transfers/history';
import { InvestorWithdraw } from '../pages/investor/views/transfers/withdraw';
import { PageNotFound } from '../pages/pageNotFound/pageNotFound';
import { BorrowerRegistration } from '../pages/registration/borrower';
import { BorrowerBaseRegistration } from '../pages/registration/borrower/views/base';
import { BorrowerBusinessInformation } from '../pages/registration/borrower/views/businessInformation';
import { CommercialRegistration } from '../pages/registration/borrower/views/commercialRegistration';
import { BorrowerDocumentVerification } from '../pages/registration/borrower/views/document-verification';
import { BorrowerPersonalInfo } from '../pages/registration/borrower/views/personalInformation';
import { BorrowerStepper } from '../pages/registration/borrower/views/stepper';
import { AbsherVerification } from '../pages/registration/components/absherVerification';
import { NafathVerification } from '../pages/registration/components/nafathVerification';
import { ConfirmEmail } from '../pages/registration/confirmEmail';
import { InvestorRegistration } from '../pages/registration/investor';
import { InvestorBaseRegistration } from '../pages/registration/investor/views/base';
import { InvestorDocumentVerification } from '../pages/registration/investor/views/documentVerification';
import { InvestorPersonalInfo } from '../pages/registration/investor/views/personalInformation';
import { InvestorStepper } from '../pages/registration/investor/views/stepper';
import { VerifyEmail } from '../pages/registration/verifyEmail';
import { ThankYouPage } from '../pages/thankYou';
import { Winddown } from '../pages/winddown';
import { CommunicationPreference } from '../shared/components/communicationPreference';
import { TransferMethodSelection } from '../pages/investor/views/transfers/transferMethodSelection/index';
import { UserNafathVerification } from '../shared/components/userNafathVerification';
import InvestorLayout from '../shared/layouts/mainLayout/investorLayout';
import { MainLayout } from "../shared/layouts/mainLayout";
import BorrowerLayout from '../shared/layouts/mainLayout/borrowerLayout';
import { RegionHandler } from "../shared/layouts/regionHandler";
import { ExternalIntegration } from '../pages/investor/views/profile/integration';
import {Checkout} from "../pages/investor/views/transfers/payment/checkout"
import {PaymentResult} from "../pages/investor/views/transfers/payment/result"

// Conditional redirect component for transfer default route
const TransferDefaultRedirect = () => {
	const targetRoute = IS_SA ? AppRoutes.ITransferMethods : AppRoutes.IDeposit;
	return <Navigate to={targetRoute} />;
};

export const routes = [
	{
		path: '/*',
		element: <RegionHandler />,
	},
	{
		path: ':region',
		element: <MainLayout />,
		children: [
			{
				path: '',
				element: <Navigate to={'en'} />,
			},
			{
				path: ':lang',
				children: [
					{ path: '', element: <Navigate to={AppRoutes.Login}></Navigate> },
					{
						path: AppRoutes.Borrower,
						element: (
							<CheckLogin>
								<BorrowerRole>
									<BorrowerLayout></BorrowerLayout>
								</BorrowerRole>
							</CheckLogin>
						),
						children: [
							{
								path: '',
								element: <Borrower></Borrower>,
								children: [
									{ path: '', element: <BorrowerSummary></BorrowerSummary> },
									{
										path: AppRoutes.BPaymentSchedule,
										element: (
											<BorrowerPaymentSchedule></BorrowerPaymentSchedule>
										),
									},
									{
										path: AppRoutes.BTransfers,
										element: <BorrowerTransfers></BorrowerTransfers>,
									},
									{
										path: AppRoutes.BBankTransfer,
										element: <BankTransfer></BankTransfer>,
									},
									{
										path: AppRoutes.BDepositHistory,
										element: <DepositHistory></DepositHistory>,
									},
									{
										path: AppRoutes.Profile,
										element: <BorrowerProfile></BorrowerProfile>,
										children: [
											{
												path: '',
												element: (
													<BorrowerProfileSections></BorrowerProfileSections>
												),
												children: [
													{
														path: '',
														element: (
															<Navigate
																to={AppRoutes.IProfileUpdate}></Navigate>
														),
													},
													{
														path: AppRoutes.IProfileUpdate,
														element: (
															<BorrowerUpdateDetails></BorrowerUpdateDetails>
														),
													},
													{
														path: AppRoutes.IChangePassword,
														element: (
															<BorrowerChangePassword></BorrowerChangePassword>
														),
													},
													{
														path: AppRoutes.IDeactivateAccount,
														element: (
															<BorrowerDeactivateAccount></BorrowerDeactivateAccount>
														),
													},
												],
											},
										],
									},
									{
										path: AppRoutes.BChangePassword,
										element: <BorrowerChangePassword></BorrowerChangePassword>,
									},
								],
							},
						],
					},
					{
						path: AppRoutes.Investor,
						element: (
							<InvestorRole>
								<InvestorLayout></InvestorLayout>
							</InvestorRole>
						),
						children: [
							{
								path: '',
								element: <Investor></Investor>,
								children: [
									{
										path: '',
										element: (
											<CheckLogin>
												<InvestorSummary></InvestorSummary>
											</CheckLogin>
										),
									},
									{
										path: AppRoutes.Marketplace,
										children: [
											{
												path: '',
												element: (
													<CheckLogin>
														<Marketplace></Marketplace>
													</CheckLogin>
												),
											},
											{
												path: `${AppRoutes.MarketplaceBusinessDetails}/:id`,
												element: (
													<CheckLogin>
														<MarketplaceDetails></MarketplaceDetails>
													</CheckLogin>
												),
											},
											{
												path: `${AppRoutes.MarketplaceCollectionDetails}/:id`,
												element: (
													<CheckLogin>
														<MarketplaceCollectionDetails></MarketplaceCollectionDetails>
													</CheckLogin>
												),
											},
											{
												path: AppRoutes.MarketplaceBusinessHistory,
												children: [
													{
														path: `:id`,
														element: (
															<CheckLogin>
																<BusinessDetailsHistory></BusinessDetailsHistory>
															</CheckLogin>
														),
													},
													{
														path: `:id/${AppRoutes.IPaymentSchedule}`,
														element: (
															<CheckLogin>
																<PaymentSchedule></PaymentSchedule>
															</CheckLogin>
														),
													},
												],
											},
										],
									},
									{
										path: AppRoutes.MyInvestments,
										element: (
											<CheckLogin>
												<Portfolio></Portfolio>
											</CheckLogin>
										),
									},
									{
										path: AppRoutes.InvestmentSettings,
										element: (
											<CheckLogin>
												<AutoInvesting></AutoInvesting>
											</CheckLogin>
										),
									},
									{
										path: AppRoutes.ITransfer,
										element: (
											<CheckLogin>
												<InvestorTransferGuard>
													<InvestorTransfer></InvestorTransfer>
												</InvestorTransferGuard>

											</CheckLogin>
										),
										children: [
											{
												path: '',
												element: <TransferDefaultRedirect />,
											},
											{ 
												path: AppRoutes.ITransferMethods,
												element: ( 
													<CheckLogin>
														<KSATransferGuard>
															<TransferMethodSelection></TransferMethodSelection>
														</KSATransferGuard>
													</CheckLogin> 
												), 
											},
											{
												path: AppRoutes.IDeposit,
												element: (
													<CheckLogin>
														<InvestorDeposit></InvestorDeposit>
													</CheckLogin>
												),
											},
											{
												path: AppRoutes.IWithdraw,
												element: (
													<CheckLogin>
														<InvestorWithdraw></InvestorWithdraw>
													</CheckLogin>
												),
											},
											{
										path: AppRoutes.IPayment,
										children: [
											{
												path: AppRoutes.IPaymentCheckout,
												element: (
													<CheckLogin>
														<KSATransferGuard>
															<Checkout></Checkout>
														</KSATransferGuard>
													</CheckLogin>
												),
											},
											{
												path: AppRoutes.IPaymentResult,
												element: (
													<CheckLogin>
														<KSATransferGuard>
															<PaymentResult></PaymentResult>
														</KSATransferGuard>
													</CheckLogin>
												),
											},
										],
									},
											{
												path: AppRoutes.ITransactionHistory,
												element: (
													<CheckLogin>
														<InvestorTransferHistory></InvestorTransferHistory>
													</CheckLogin>
												),
											},
											{
												path: AppRoutes.IDepositHistory,
												element: (
													<CheckLogin>
														<InvestorDepositHistory></InvestorDepositHistory>
													</CheckLogin>
												),
											},
										],
									},
									{
										path: AppRoutes.Profile,
										element: (
											<CheckLogin>
												<InvestorProfile></InvestorProfile>
											</CheckLogin>
										),
										children: [
											{
												path: '',
												element: <ProfileSections></ProfileSections>,
												children: [
													{
														path: '',
														element: (
															<Navigate
																to={AppRoutes.IProfileUpdate}></Navigate>
														),
													},
													{
														path: AppRoutes.IProfileUpdate,
														element: (
															<InvestorUpdateDeatils></InvestorUpdateDeatils>
														),
													},
													{
														path: AppRoutes.IProfileIntegration,
														element: (
															<ExternalIntegration></ExternalIntegration>
														),
													},
													{
														path: AppRoutes.BecomeAPro,
														element: <BecomeProInvestor></BecomeProInvestor>,
													},
													{
														path: AppRoutes.IChangePassword,
														element: (
															<InvestorChangePassword></InvestorChangePassword>
														),
													},
													{
														path: AppRoutes.INafathVerification,
														element: (
															<UserNafathGuard>
																<UserNafathVerification></UserNafathVerification>
															</UserNafathGuard>

														),
													},
													{
														path: AppRoutes.IDeactivateAccount,
														element: (
															<InvestorDeactivateAccount></InvestorDeactivateAccount>
														),
													},
													{
														path: AppRoutes.CommunicationPreference,
														element: (
															<CommunicationPreference></CommunicationPreference>
														),
													},
												],
											},
										],
									},
									{
										path: AppRoutes.ITransactionStatements,
										element: (
											<CheckLogin>
												<TransactionStatements></TransactionStatements>
											</CheckLogin>
										),
									},
									{
										path: AppRoutes.ITransactionStatements,
										element: (
											<CheckLogin>
												<TransactionStatements></TransactionStatements>
											</CheckLogin>
										),
									},
								],
							},
						],
					},
					{
						path: AppRoutes.InvestorRegistration,
						element: (
							<RegistrationLoginCheck>
								<InvestorRegistration></InvestorRegistration>
							</RegistrationLoginCheck>
						),
						children: [
							{
								path: '',
								element: <Navigate to={AppRoutes.IRegFirstStep}></Navigate>,
							},
							{
								path: AppRoutes.IRegFirstStep,
								element: <InvestorBaseRegistration></InvestorBaseRegistration>,
							},
							{
								path: AppRoutes.IRegFirstStepInternational,
								element: <InvestorBaseRegistration isKsaInternationalInvestor={true} />,
							},
							{
								path: '',
								element: <InvestorStepper></InvestorStepper>,
								children: [
									{
										path: AppRoutes.IRegNafathVerification,
										element: (
											<NafathVerificationGuard>
												<NafathVerification></NafathVerification>
											</NafathVerificationGuard>
										),
									},
									{
										path: AppRoutes.IRegAbsherVerification,
										element: (
											<AbsherVerificationGuard>
												<AbsherVerification></AbsherVerification>
											</AbsherVerificationGuard>
										),
									},
									{
										path: AppRoutes.IRegPersonalInfo,
										element: <InvestorPersonalInfo></InvestorPersonalInfo>,
									},
									{
										path: AppRoutes.iRegDocumentVarification,
										element: (
											<InvestorDocumentVerification></InvestorDocumentVerification>
										),
									},
								],
							},
						],
					},
					{
						path: AppRoutes.BorrowerRegistartion,
						element: (
							<RegistrationLoginCheck>
								<BorrowerRegistration></BorrowerRegistration>
							</RegistrationLoginCheck>
						),
						children: [
							{
								path: '',
								element: <Navigate to={AppRoutes.BRegFirstStep}></Navigate>,
							},
							{
								path: AppRoutes.IRegFirstStep,
								element: <BorrowerBaseRegistration></BorrowerBaseRegistration>,
							},
							{
								path: '',
								element: <BorrowerStepper></BorrowerStepper>,
								children: [
									{
										path: AppRoutes.IRegNafathVerification,
										element: (
											<NafathVerificationGuard>
												<NafathVerification></NafathVerification>
											</NafathVerificationGuard>
										),
									},
									{
										path: AppRoutes.BRegPersonalInfo,
										element: <BorrowerPersonalInfo></BorrowerPersonalInfo>,
									},
									{
										path: AppRoutes.CommercialRegistration,
										element: <CommercialRegistration></CommercialRegistration>,
									},
									{
										path: AppRoutes.BRegBusinessInfo,
										element: (
											<BorrowerBusinessInformation></BorrowerBusinessInformation>
										),
									},
									{
										path: AppRoutes.BRegDocumentVarification,
										element: (
											<BorrowerDocumentVerification></BorrowerDocumentVerification>
										),
									},
								],
							},
						],
					},
					{
						path: AppRoutes.Login,
						element: (
							<AlreadyLogin>
								<Login></Login>
							</AlreadyLogin>
						),
					},
					{
						path: AppRoutes.WindDown,
						element: <Winddown></Winddown>,
					},
					{
						path: `${AppRoutes.Investor}/${AppRoutes.ThankYou}`,
						element: (
							<ThankYouPageGuard>
								<ThankYouPage></ThankYouPage>
							</ThankYouPageGuard>
						),
					},
					{
						path: `${AppRoutes.Borrower}/${AppRoutes.ThankYou}`,
						element: (
							<ThankYouPageGuard>
								<ThankYouPage></ThankYouPage>
							</ThankYouPageGuard>
						),
					},
					
					{
						path: AppRoutes.ForgotPassword,
						element: (
							<AlreadyLogin>
								<ForgotPassword></ForgotPassword>
							</AlreadyLogin>
						),
					},
					{
						path: AppRoutes.VerifyEmail,
						element: (
							<VerifyEmail></VerifyEmail>
						),
					},
					{
						path: AppRoutes.ConfirmEmail,
						element: (
							<ConfirmEmail></ConfirmEmail>
						),
					},
					{
						path: AppRoutes.ResetPassword,
						element: (
							<AlreadyLogin>
								<ResetPassword></ResetPassword>
							</AlreadyLogin>
						),
					},
					{
						path: '*',
						element: <PageNotFound />,
					},
				],
			},
		],
	},

	{
		path: '*',
		element: <PageNotFound />,
	},
];

export default function Router() {
	return useRoutes(routes);
}
